import { backUrl } from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";

export const uploadImage = async (formData) => {
  const uploadReq = await apiFetch(`${backUrl}/fileUpload/uploadImage`, {
    method: "POST",
    body: formData,
  });
  const uploadRes = await uploadReq.json();
  return uploadRes;
};

export const uploadFile = async (formData) => {
  const uploadReq = await apiFetch(`${backUrl}/fileUpload/uploadFile`, {
    method: "POST",
    body: formData,
  });
  const uploadRes = await uploadReq.json();
  return uploadRes;
};
